// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Noto+Sans+JP:400,700&display=swap&subset=japanese);"]);
// Module
exports.push([module.id, ".mc-mentor-info[data-v-7aca4dd2]{padding:32px 0}.mc-mentor-info *[data-v-7aca4dd2]{box-sizing:content-box}", ""]);
// Exports
module.exports = exports;
